module.exports = __webpack_public_path__ + "assets/img/yyindex-8.87e12974.png";